<template>
  <div>
    <VueSlickCarousel class="categorySlider" v-bind="categorySettings">
      <div v-for="item in items" :key="item.id">
        <a v-if="item.mediadata" href="" @click.prevent="showDetail(item)">
          <img
            v-if="item.mediadata"
            :src="thumbnail(item.mediadata.titleImage)"
          />
        </a>
        <div class="has-text-centered is-hidden-desktop">
          <a v-if="item.mediadata" href="" @click.prevent="showDetail(item)"
            >View</a
          >
        </div>
      </div>
      <template #prevArrow="arrowOption">
        <div class="custom-arrow">
          <b-icon icon="chevron-left" size="is-medium" />
        </div>
      </template>
      <template #nextArrow="arrowOption">
        <div class="custom-arrow">
          <b-icon icon="chevron-right" size="is-medium" />
        </div>
      </template>
    </VueSlickCarousel>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import MediaDetailModal from '@/components/MediaDetailModal'
import AuthRequiredModal from '@/components/AuthRequiredModal'
import Utils from '@/mixins/utils'

export default {
  name: 'CategorySlider',
  components: {
    VueSlickCarousel
  },
  mixins: [Utils],
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      categorySettings: {
        dots: false,
        arrows: true,
        dotsClass: 'slick-dots custom-dot-class',
        edgeFriction: 0.35,
        infinite: false,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        lazyLoad: 'ondemand',
        responsive: [
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2
            },
            centerMode: true,
            centerPadding: '20px'
          }
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['isAuthenticated'])
  },
  methods: {
    showDetail(item) {
      if (this.isAuthenticated) {
        this.$buefy.modal.open({
          parent: this,
          component: MediaDetailModal,
          hasModalCard: true,
          props: {
            id: item.media_id ? item.media_id : item.id
          },
          trapFocus: true
        })
      } else {
        this.$buefy.modal.open({
          parent: this,
          component: AuthRequiredModal,
          hasModalCard: true,
          trapFocus: true
        })
      }
    }
  }
}
</script>

<style>
.categorySlider .slick-slide {
  padding-right: 15px;
}

.slick-prev,
.slick-next {
  font-size: 0;
  line-height: 0;

  position: absolute;
  top: 50%;

  display: block;

  padding: 0;
  -webkit-transform: translate(0, -50%);
  -ms-transform: translate(0, -50%);
  transform: translate(0, -50%);

  cursor: pointer;
  border: none;
  outline: none;
  background: transparent;
  z-index: 2;

  font-size: 20px;
  line-height: 1;

  opacity: 0.75;
  color: black;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.slick-prev:hover,
.slick-prev:focus,
.slick-next:hover,
.slick-next:focus {
  outline: none;
  background: transparent;
}
.slick-prev:hover,
.slick-prev:focus,
.slick-next:hover,
.slick-next:focus {
  opacity: 1;
}
.slick-prev.slick-disabled,
.slick-next.slick-disabled {
  opacity: 0.25;
}

.slick-prev {
  left: -35px;
}

.slick-next {
  right: -25px;
}
</style>
